export enum CharacterGender {
    MALE = 'Male',
    FEMALE = 'Female',
}